import { ReactElement } from 'react';
import { ContentAlert } from '@client/common/components/Modal/ModalContents';
import { useTranslate } from '@client/i18n/hooks';
import { ALERT_STYLE_TYPE } from 'b2b-components/core/components/Alert';
import { Modal, MODAL_TYPE } from 'b2b-components/theme/components/Modal';
import { useRestockSubscribeData } from 'b2b-apps/core/product/hooks';
import { Form } from './Form';
import { Props } from './';

export const RestockModal = ({
  isOpen,
  onClose,
  sku,
}: Props): ReactElement => {
  const restockSubscribeData = useRestockSubscribeData();
  const { hasFailed } = restockSubscribeData;
  const t = useTranslate();

  return (
    <Modal
      title={t('Notify when available')}
      content={() => (
        <>
          {t('You will receive one-time e-mail notification when the product is back in stock')}

          {hasFailed && (
              <ContentAlert
                text={t('Could not submit your request, please try again.')}
                alertType={ALERT_STYLE_TYPE.error}
              />
          )}

          <Form sku={sku} onDiscardClick={onClose} />
        </>
      )}
      isOpen={isOpen}
      onCloseModal={onClose}
      type={MODAL_TYPE.small}
    />
  );
};
